import { EMAIL_REGEX, GST_REGEX, PHONE_REGEX } from "../constant/regex";

export const VendorValidationSchema = (json) => {
  const MyPromiss = new Promise((resolve, reject) => {
    var errorJson = {};

    // Helper function to safely handle string operations
    const safeStringTrim = (value) => {
      if (value === null || value === undefined) return '';
      return typeof value === 'string' ? value.trim() : String(value).trim();
    };


    if (!json?.vendorName || safeStringTrim(json.vendorName) === "") {
      Object.assign(errorJson, { vendorName: "Vendor name cannot be empty *" });
    } else if (safeStringTrim(json.vendorName).length < 2) {
      Object.assign(errorJson, { vendorName: "Vendor name must be at least 2 characters *" });
    }

    // GST Number validation
    if (!json?.gst || safeStringTrim(json.gst) === "") {
      Object.assign(errorJson, { gst: "GST number cannot be empty *" });
    } else if (!GST_REGEX.test(safeStringTrim(json.gst))) {
      Object.assign(errorJson, { gst: "Please enter a valid GST number *" });
    }

    // Address validation
    if (!json?.address || safeStringTrim(json.address) === "") {
      Object.assign(errorJson, { address: "Address cannot be empty *" });
    } else if (safeStringTrim(json.address).length < 10) {
      Object.assign(errorJson, { address: "Address must be at least 10 characters *" });
    }

    // State validation
    if (!json?.state || safeStringTrim(json.state) === "") {
      Object.assign(errorJson, { state: "State cannot be empty *" });
    }

    // Contact Number validation
    if (!json?.contact || safeStringTrim(json.contact) === "") {
      Object.assign(errorJson, { contact: "Contact number cannot be empty *" });
    } else if (!PHONE_REGEX.test(safeStringTrim(json.contact))) {
      Object.assign(errorJson, { contact: "Contact number must be exactly 10 digits *" });
    }

    // Email validation
    if (!json?.email || safeStringTrim(json.email) === "") {
      Object.assign(errorJson, { email: "Email cannot be empty *" });
    } else if (!EMAIL_REGEX.test(safeStringTrim(json.email))) {
      Object.assign(errorJson, { email: "Please enter a valid email address *" });
    }

    resolve(errorJson);
  });

  return MyPromiss;
};